import React from 'react';
import { getShapeBoundingBox as getShapeBoundingBoxUtil } from './shapes';

function getShapeBoundingBox(s) {
  return getShapeBoundingBoxUtil(s);
}

export default function WhiteboardSelectionOverlay({
  selectionRectRef, pan,
  isViewOnly, shapes, selectedShapes,
  isGroupDragging, isGroupResizing,
  handleGroupMouseDown, handleGroupMouseMove, handleGroupMouseUp,
  handleGroupResizeMouseDown, handleGroupResizeMouseMove, handleGroupResizeMouseUp,
}) {
  return (
    <>
      {/* Selection rubber-band box — position/size mutated directly by useWhiteboardBoardHandlers */}
      <div
        ref={selectionRectRef}
        style={{
          display: 'none',
          position: 'fixed',
          border: '1.5px dashed #2563eb',
          background: 'rgba(37,99,235,0.08)',
          zIndex: 2000,
          pointerEvents: 'none',
          boxSizing: 'border-box',
        }}
      />

      {/* Blue frame around each individually selected shape */}
      {!isViewOnly && selectedShapes.length > 0 && shapes.map(s => {
        if (!selectedShapes.includes(s.id)) return null;
        const box = getShapeBoundingBox(s);
        return (
          <svg
            key={s.id + '_selbox'}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
              pointerEvents: 'none',
              zIndex: 12,
            }}
          >
            <line x1={(box.x - 8) * pan.scale + pan.x} y1={(box.y - 8) * pan.scale + pan.y} x2={(box.x + box.width + 8) * pan.scale + pan.x} y2={(box.y - 8) * pan.scale + pan.y} stroke="#3b82f6" strokeWidth="1" strokeLinecap="round" />
            <line x1={(box.x + box.width + 8) * pan.scale + pan.x} y1={(box.y - 8) * pan.scale + pan.y} x2={(box.x + box.width + 8) * pan.scale + pan.x} y2={(box.y + box.height + 8) * pan.scale + pan.y} stroke="#3b82f6" strokeWidth="1" strokeLinecap="round" />
            <line x1={(box.x + box.width + 8) * pan.scale + pan.x} y1={(box.y + box.height + 8) * pan.scale + pan.y} x2={(box.x - 8) * pan.scale + pan.x} y2={(box.y + box.height + 8) * pan.scale + pan.y} stroke="#3b82f6" strokeWidth="1" strokeLinecap="round" />
            <line x1={(box.x - 8) * pan.scale + pan.x} y1={(box.y + box.height + 8) * pan.scale + pan.y} x2={(box.x - 8) * pan.scale + pan.x} y2={(box.y - 8) * pan.scale + pan.y} stroke="#3b82f6" strokeWidth="1" strokeLinecap="round" />
          </svg>
        );
      })}

      {/* Group bounding box + resize handles */}
      {selectedShapes.length > 0 && (() => {
        const group = shapes.filter(s => selectedShapes.includes(s.id));
        if (!group.length) return null;
        const xs = group.map(s => getShapeBoundingBox(s).x);
        const ys = group.map(s => getShapeBoundingBox(s).y);
        const ws = group.map(s => getShapeBoundingBox(s).x + getShapeBoundingBox(s).width);
        const hs = group.map(s => getShapeBoundingBox(s).y + getShapeBoundingBox(s).height);
        const minX = Math.min(...xs);
        const minY = Math.min(...ys);
        const maxX = Math.max(...ws);
        const maxY = Math.max(...hs);
        const box = { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
        const handles = [
          { corner: 'nw', x: box.x - 8, y: box.y - 8 },
          { corner: 'ne', x: box.x + box.width + 8, y: box.y - 8 },
          { corner: 'sw', x: box.x - 8, y: box.y + box.height + 8 },
          { corner: 'se', x: box.x + box.width + 8, y: box.y + box.height + 8 },
        ];
        return (
          <svg
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
              pointerEvents: 'auto',
              zIndex: 12,
              cursor: isGroupDragging ? 'grabbing' : 'grab',
            }}
            onMouseDown={handleGroupMouseDown}
            onPointerDown={handleGroupMouseDown}
            onMouseMove={isGroupResizing ? handleGroupResizeMouseMove : handleGroupMouseMove}
            onPointerMove={isGroupResizing ? handleGroupResizeMouseMove : handleGroupMouseMove}
            onMouseUp={isGroupResizing ? handleGroupResizeMouseUp : handleGroupMouseUp}
            onPointerUp={isGroupResizing ? handleGroupResizeMouseUp : handleGroupMouseUp}
          >
            <line x1={(box.x - 8) * pan.scale + pan.x} y1={(box.y - 8) * pan.scale + pan.y} x2={(box.x + box.width + 8) * pan.scale + pan.x} y2={(box.y - 8) * pan.scale + pan.y} stroke="#3b82f6" strokeWidth="1" strokeLinecap="round" />
            <line x1={(box.x + box.width + 8) * pan.scale + pan.x} y1={(box.y - 8) * pan.scale + pan.y} x2={(box.x + box.width + 8) * pan.scale + pan.x} y2={(box.y + box.height + 8) * pan.scale + pan.y} stroke="#3b82f6" strokeWidth="1" strokeLinecap="round" />
            <line x1={(box.x + box.width + 8) * pan.scale + pan.x} y1={(box.y + box.height + 8) * pan.scale + pan.y} x2={(box.x - 8) * pan.scale + pan.x} y2={(box.y + box.height + 8) * pan.scale + pan.y} stroke="#3b82f6" strokeWidth="1" strokeLinecap="round" />
            <line x1={(box.x - 8) * pan.scale + pan.x} y1={(box.y + box.height + 8) * pan.scale + pan.y} x2={(box.x - 8) * pan.scale + pan.x} y2={(box.y - 8) * pan.scale + pan.y} stroke="#3b82f6" strokeWidth="1" strokeLinecap="round" />
            {handles.map((h) => (
              <circle
                key={h.corner}
                cx={h.x * pan.scale + pan.x}
                cy={h.y * pan.scale + pan.y}
                r={4}
                fill="#fff"
                stroke="#3b82f6"
                strokeWidth="1"
                style={{ cursor: h.corner + '-resize', pointerEvents: 'auto', zIndex: 1000 }}
                onMouseDown={e => handleGroupResizeMouseDown(e, h.corner)}
                onPointerDown={e => handleGroupResizeMouseDown(e, h.corner)}
              />
            ))}
          </svg>
        );
      })()}
    </>
  );
}
